import Vue from 'vue'
import axios from 'axios'
import router from "../router"
import {
    VueAxios
} from './axios'

const service = axios.create({

})

axios.defaults.headers.post['responseType'] = 'blob';

const err = (error) => {
    // Vue.ls.remove('Authorization')
    switch (error.response && error.response.status) {
        case 400:
            console.error(error.response.status, error.message);
            console.warn("Nothing to display", "Data Not Found");
            break;

        case 401: // authentication error, logout the user
            console.warn("Please login again", "Session Expired");
            router.push("/");
            break;
        default:
            console.error(error.response.status, error.message);

    }
    return Promise.reject(error);
}

// request interceptor
service.interceptors.request.use(config => {
    // config.headers['Access-Control-Allow-Origin'] = '*'
    const token = Vue.ls.get('Authorization')
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
    let res;
    res = (response.config.responseType == "blob") ? response : response.data
    return res;

}, err)
const installer = {
    vm: {},
    install(Vue) {
        Vue.use(VueAxios, service)
    }
}

export {
    installer as VueAxios,
    service as axios
}